import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { SoundFamiliar } from './components/SoundFamiliar';
import { CoreInsight } from './components/CoreInsight';
import { ProductReveal } from './components/ProductReveal';
import { WhatYouGet } from './components/WhatYouGet';
import { ToolkitPreview } from './components/ToolkitPreview';
import { Bonuses } from './components/Bonuses';
import { Benefits } from './components/Benefits';
import { HowItWorks } from './components/HowItWorks';
import { Offer } from './components/Offer';
import { Guarantee } from './components/Guarantee';
import { Testimonials } from './components/Testimonials';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { PurchaseNotifications } from './components/PurchaseNotifications';
type AppProps = {
  showPurchaseNotifications?: boolean;
};
export function App({
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full overflow-x-hidden bg-ivory font-sans text-navy" data-id="element-0" data-mp="3ijpdn24eb1aa">
      <Hero data-id="element-1" data-mp="3mk85gw6ag7ch" />
      <main data-id="element-2" data-mp="3mjq1fdddwou0">
        <SoundFamiliar data-id="element-3" data-mp="3mjg7xft4rzjk" />
        <CoreInsight data-id="element-4" data-mp="3rcj5s04xxv5k" />
        <ProductReveal data-id="element-5" data-mp="3rbzo8kj7d8s2" />
        <WhatYouGet data-id="element-6" data-mp="3rcsy3udgkeef" />
        <ToolkitPreview data-id="element-7" data-mp="3recd7hndojem" />
        <Bonuses data-id="element-8" data-mp="5ot150vj28n" />
        <Benefits data-id="element-9" data-mp="67znpl2q47d" />
        <HowItWorks data-id="element-10" data-mp="4n53zyrel9i" />
        <Offer data-id="element-11" data-mp="56m9egl55mh" />
        <Guarantee data-id="element-12" data-mp="7svdij4jt6t" />
        <Testimonials data-id="element-13" data-mp="2zld2jatxbhc2" />
        <Faq data-id="element-14" data-mp="2zm4y4lnitf2c" />
        <FinalCta data-id="element-15" data-mp="2zmenc70qri6z" />
      </main>
      {showPurchaseNotifications ? <PurchaseNotifications data-id="element-16" data-mp="33mf623uvifju" /> : null}
    </div>;
}